import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import en from './en';
import tr from './tr';
import ru from './ru';
import ue from './ue';

const locales = { tr, en, ru, ue };

Vue.config.lang = 'tr';

Object.keys(locales).forEach(function (lang) {
  Vue.locale(lang, locales[lang]);
});



// WEBPACK FOOTER //
// ./src/lang/translation.js